import { render, staticRenderFns } from "./ChangesList.vue?vue&type=template&id=709b9d51"
import script from "./ChangesList.vue?vue&type=script&lang=js"
export * from "./ChangesList.vue?vue&type=script&lang=js"
import style0 from "./ChangesList.vue?vue&type=style&index=0&id=709b9d51&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports